import moment from 'moment';

export default {
    getFinancialWeek(weekStartDate, financialYearCalendars) {
        let financialYearCalendar = null;   
        for (let index = 0; index < financialYearCalendars.length; index++) {
            const startDate = financialYearCalendars[index].StartDate;
            if (moment(weekStartDate).isSameOrAfter(moment(startDate)) && index < financialYearCalendars.length - 1 && moment(weekStartDate).isBefore(financialYearCalendars[index + 1].StartDate)) {
                financialYearCalendar = financialYearCalendars[index];
                break;
            }

            if (moment(weekStartDate).isSameOrAfter(moment(startDate)) && index == financialYearCalendars.length - 1 && moment(weekStartDate).year() == moment(startDate).year()) {
                financialYearCalendar = financialYearCalendars[index];
                break;
            }
        }

        if (financialYearCalendar) {
            return moment(weekStartDate).diff(moment(financialYearCalendar.StartDate), 'week') + 1;
        } else {
            return "N/A";
        }
    },
    getFinancialYear(weekStartDate, financialYearCalendars) {
        let financialYearCalendar = null;
        for (let index = 0; index < financialYearCalendars.length; index++) {
            const startDate = financialYearCalendars[index].StartDate;
            if (moment(weekStartDate).isSameOrAfter(moment(startDate)) && index < financialYearCalendars.length - 1 && moment(weekStartDate).isBefore(financialYearCalendars[index + 1].StartDate)) {
                financialYearCalendar = financialYearCalendars[index];
                break;
            }

            if (moment(weekStartDate).isSameOrAfter(moment(startDate)) && index == financialYearCalendars.length - 1 && moment(weekStartDate).year() == moment(startDate).year()) {
                financialYearCalendar = financialYearCalendars[index];
                break;
            }
        }

        if (financialYearCalendar) {
            return financialYearCalendar.FinancialYear;
        } else {
            return "N/A";
        }
    },
    setDaytoSpray(cropLocationVarieties) {
        cropLocationVarieties.Varieties.forEach(v => {
            let total = v.Rosters.map(r => r.RosterValue).reduce((a, b) => a + b);
            if (v.Rosters.find(r => r.IsSpray) == null) {
                v.Rosters.push({
                    BerriesRosterID: -1,
                    CropLocationID: cropLocationVarieties.CropLocationID,
                    VarietyID: v.VarietyID,
                    TeamID: null,
                    RosterValue: total,
                    IsSpray: true,
                    RosterDate: cropLocationVarieties.Date,
                    RequireRecalculate: true,
                    Delete: false
                });
            }
            v.Rosters.forEach(r => {
                if (!r.IsSpray) {
                    r.Delete = true;
                }
            });
        })
        return cropLocationVarieties;
    },
    addUpdateTeamRosters(cropLocationVarieties, selectedTeamIDs) {
        // allocate the volume for each selected team
        cropLocationVarieties.Varieties.forEach(v => {
            // if not team is selected, keep the original volume
            if(selectedTeamIDs.length == 0) {
                var noTeamRoster = {
                    BerriesRosterID: -1,
                    CropLocationID: cropLocationVarieties.CropLocationID,
                    VarietyID: v.VarietyID,
                    TeamID: null,
                    RosterValue: v.ForecastValue,
                    IsSpray: false,
                    RosterDate: cropLocationVarieties.Date,
                    RequireRecalculate: true,
                    Delete: false
                };
                v.Rosters.map(r => {
                    r.Delete = true;
                    return false;
                });
                v.Rosters.push(noTeamRoster);
            } else {
                // Allocate the volume to each team 
                selectedTeamIDs.forEach(t => {
                    var rosterValue = null;
                    v.Rosters.forEach(r=> {
                        if(r.RosterValue != null) {
                            if(rosterValue == null) {
                                rosterValue = r.RosterValue;
                            } else {
                                rosterValue = rosterValue + r.RosterValue;
                            }
                        }
                    });
                    if(rosterValue != null) {
                        rosterValue = rosterValue / selectedTeamIDs.length;
                    } else {
                        rosterValue = v.ForecastValue / selectedTeamIDs.length;
                    }
                    var existRoster = v.Rosters.find(r => r.TeamID == t && r.VarietyID == v.VarietyID);
                    if (existRoster != null) {
                        existRoster.RosterValue = rosterValue;
                        existRoster.Delete = false;
                        existRoster.RequireRecalculate = true;
                        existRoster.IsSpray = false;
                    } else {
                        v.Rosters.push({
                            BerriesRosterID: -1,
                            CropLocationID: cropLocationVarieties.CropLocationID,
                            VarietyID: v.VarietyID,
                            TeamID: t,
                            RosterValue: rosterValue,
                            IsSpray: false,
                            RosterDate: cropLocationVarieties.Date,
                            RequireRecalculate: true,
                            Delete: false
                        })
                    }
                })
                v.Rosters.forEach(r => {
                    if (!r.TeamID || selectedTeamIDs.indexOf(r.TeamID) < 0) {
                        r.Delete = true;
                    }
                });
            }
        });
        return cropLocationVarieties;
    },
    addUpdateMixedTeamRosters(cropLocationVarieties, cropLocationVarietyDayRosters, teamRosterItems) {
        // based on the team roster items (the volume allocated in the team mixed popup), update/delete/add the roster enties
        cropLocationVarieties.Varieties.forEach(v => {
            var rosters = [];
            teamRosterItems.filter(t=> t.VarietyID == v.VarietyID).forEach(t => {

                var existRoster = cropLocationVarietyDayRosters.Varieties.find(vv=> vv.VarietyID == t.VarietyID).Rosters.find(r=> r.TeamID == t.TeamID);
                // If the volume is null, and existing roster is not null, delete it
                if (t.Volume == null) {
                    if(existRoster != null) {
                        existRoster.Delete = true;
                        rosters.push(existRoster);
                    }
                } else{
                    // If volume is not null and existing entry exists. update the volume
                    if(existRoster != null) {
                        existRoster.RosterValue = t.Volume;
                        existRoster.IsSpray = false;
                        existRoster.RequireRecalculate = true;
                        existRoster.Delete = false;
                        rosters.push(existRoster);
                    } else {
                        // Add the new entry
                        rosters.push({
                            BerriesRosterID: -1,
                            CropLocationID: cropLocationVarieties.CropLocationID,
                            VarietyID: t.VarietyID,
                            TeamID: t.TeamID,
                            RosterValue: t.Volume,
                            IsSpray: false,
                            RosterDate: cropLocationVarietyDayRosters.Date,
                            RequireRecalculate: true,
                            Delete: false
                        });
                    }
                }
            })
            var existVariety = cropLocationVarietyDayRosters.Varieties.find(clv=> clv.VarietyID == v.VarietyID);
            if(existVariety) {
                // set the delete flag if the team does not belong and allocate to this crop location variety
                var deleteRosters = existVariety.Rosters.filter(r=> rosters.find(rr=> rr.TeamID == r.TeamID) == null && r.Delete == false);
                deleteRosters.forEach(dr=> {
                    dr.Delete = true;
                    return dr;
                })
                existVariety.Rosters = rosters.concat(deleteRosters);
            } else {
                cropLocationVarietyDayRosters.Varieties.push({
                    VarietyID: v.VarietyID,
                    VarietyName: v.VarietyName,
                    Rosters: rosters,
                    ForecatValue: null
                })
            }
        });
        return cropLocationVarietyDayRosters;
    },
    addUpdateMixedVarietyRosters(cropLocationVarieties, teamVarietyItems) {
        cropLocationVarieties.Varieties.forEach(v=> {
            var teamVarietyItem = teamVarietyItems.find(vi=> vi.VarietyID == v.VarietyID);
            if(teamVarietyItem) {

                if(v.Rosters.length == 0) {
                    v.Rosters.push({
                        BerriesRosterID: -1,
                        CropLocationID: cropLocationVarieties.CropLocationID,
                        VarietyID: v.VarietyID,
                        TeamID: null,
                        RosterValue: teamVarietyItem.Volume,
                        IsSpray: false,
                        RosterDate: cropLocationVarieties.Date,
                        RequireRecalculate: true,
                        Delete: false
                    })
                } else {
                    v.Rosters.forEach(r=> {
                        r.TeamID = null;
                        r.IsSpray = null;
                        r.Delete = false;
                        r.RequireRecalculate = true;
                        r.RosterValue = Math.round(teamVarietyItem.Volume / v.Rosters.length)
                    })
                }
            }
        })
        return cropLocationVarieties;
    },
    isSameDate(d1, d2) {
        var date1 = new Date(d1);
        var date2 = new Date(d2);
        const datesAreOnSameDay = (first, second) =>
            first.getFullYear() === second.getFullYear() &&
            first.getMonth() === second.getMonth() &&
            first.getDate() === second.getDate();
        return datesAreOnSameDay(date1, date2);
    },
 
    mapRosterTeamPlans(rosterTeamPlans, days, showPreviousSunday) {
        let previousDay = null;
        if (showPreviousSunday) {
            previousDay = moment(days[0].Date);
        }

        let data = {

        };

        for (let rosterTeamPlan of rosterTeamPlans) {
            if (!data[rosterTeamPlan.TeamID]) {
                data[rosterTeamPlan.TeamID] = {
                    Days: [],
                    PreviousDayOnly: false,
                    NoPreviousDayData: false
                };
            }

            data[rosterTeamPlan.TeamID].Days.push({
                Date: rosterTeamPlan.Date,
                RosterDayOff: rosterTeamPlan.RosterDayOff,
                RosterTeamPlanID: rosterTeamPlan.RosterTeamPlanID,
                IsPreviousDay: moment(rosterTeamPlan.Date).isSame(previousDay, "day")
            });
        }

        for (let teamID in data) {
            if (Object.prototype.hasOwnProperty.call(data, teamID)) {
                let datum = data[teamID];

                datum.Days.sort();

                let includesPreviousDayData = false;
                let includesNonPreviousDayData = false;

                for (let day of datum.Days) {
                    if (showPreviousSunday && moment(day.Date).isSame(previousDay, "day")) {
                        includesPreviousDayData = true;
                    }
                    else {
                        includesNonPreviousDayData = true;
                    }
                }

                datum.PreviousDayOnly = includesPreviousDayData && !includesNonPreviousDayData;
                datum.NoPreviousDayData = !includesPreviousDayData;
            }
        }

        return data;
    },

    convertBackToKg(cropLocationVarietyRosters, uoms) {
        let data = JSON.parse(JSON.stringify(cropLocationVarietyRosters))

        for (const variety of data.Varieties) {
            for (const roster of variety.Rosters) {
                roster.RosterValue =  Math.round(roster.RosterValue / uoms[variety.VarietyID].scaleFactor);
            }
        }            

        return data;
    },

    mapCropLocationVarietyRosters(days, cropLocationsRawData, uoms, showPreviousSunday) {
        // Apply UOM scale factors to amounts
        for (const cropLocationVarietyRoster of cropLocationsRawData) {            
            for (const variety of cropLocationVarietyRoster.Varieties) {
                for (const roster of variety.Rosters) {
                    roster.RosterValue =  Math.round(roster.RosterValue * uoms[variety.VarietyID].scaleFactor);
                }

                variety.ActualsValue = Math.round((variety.ActualsValue || 0) * uoms[variety.VarietyID].scaleFactor);
            }

            for (const roster of cropLocationVarietyRoster.Rosters) {
                roster.RosterValue =  Math.round(roster.RosterValue * uoms[roster.VarietyID].scaleFactor);
            }

            for (const forecast of cropLocationVarietyRoster.Forecasts) {
                forecast.RosterValue =  Math.round(forecast.RosterValue * uoms[forecast.VarietyID].scaleFactor);
            }

            for (const actual of cropLocationVarietyRoster.Actuals) {
                actual.TotalKg =  Math.round(actual.TotalKg * uoms[actual.ProductVarietyID].scaleFactor);
            }
        }

        let previousDay = null;
        if (showPreviousSunday) {
            previousDay = moment(days[0].Date);
        }
        
        // Map the raw data in to structured model
        var cropLocationModels = [];

        cropLocationsRawData.forEach(cropLocationRawData => {
            var model = {
                PlantID: cropLocationRawData.PlantID,
                CropLocationID: cropLocationRawData.CropLocationID,
                LocationName: cropLocationRawData.LocationName,
                Days: [],
                Varieties: cropLocationRawData.Varieties,
                LocationForecastValue: 0,
                RosteredTeamIDs: [],
                IsSprayTeam: false,
                IsChecked: false,
            };

            var locationForecastValue = 0;
            let rosteredTeamsInPeriod = [];

            days.forEach(day => {
                var dayModel = {
                    Date: moment(day.Date).format("YYYY-MM-DD"),
                    IsPast: new Date().setHours(0, 0, 0, 0) > new Date(day.Date).setHours(0, 0, 0, 0),
                    Varieties: JSON.parse(JSON.stringify(cropLocationRawData.Varieties)),
                    PlantID: cropLocationRawData.PlantID,
                    CropLocationID: cropLocationRawData.CropLocationID,
                    LocationName: cropLocationRawData.LocationName,
                    ForecastDayValue: null,
                    ActualsDayValue: null,
                    IsChecked: false,
                    NuPointSprayModels: (cropLocationRawData.NuPointSprays.filter(n => this.isSameDate(n.NuPointSprayDate, day.Date)) || []).map(x => {
                        return {
                            LocationId: x.LocationID,
                            NuPointSprayDate: x.NuPointSprayDate,
                            Withholding: x.Withholding,
                            WitholdingTo: x.WitholdingTo,
                            WithholdColour: x.WithholdColour,
                            ICA: x.ICA,
                            ICAProtected: x.ICAProtected,
                            ICAProtectedFrom: x.ICAProtectedFrom,
                            ICAProtectedTo: x.ICAProtectedTo,
                            ICAColour: x.ICAColour
                        }
                    })
                };

                var withHoldingSprays = dayModel.NuPointSprayModels.filter(x => x.Withholding);

                if (withHoldingSprays.length > 0) {
                    dayModel.WithholdColour = withHoldingSprays[0].WithholdColour;
                }

                var dayActuals = cropLocationRawData.Actuals.filter(x => this.isSameDate(x.DatePicked, day.Date));
                if(dayActuals.length > 0){
                    //Sum the total KGs for each variety in todays actuals array
                    for (const actual of dayActuals) {
                        dayModel.ActualsDayValue += actual.TotalKg;
                    }
                }

                dayModel.Varieties.forEach(variety => {
                    variety.Rosters = [];
                    variety.ForecastValue = null;

                    var forecasts = cropLocationRawData.Forecasts.filter(f => this.isSameDate(f.RosterDate, day.Date) && variety.VarietyID == f.VarietyID);
                    var rosters = cropLocationRawData.Rosters.filter(r => this.isSameDate(r.RosterDate, day.Date) && variety.VarietyID == r.VarietyID);
                    
                    if (rosters.length > 0) {
                        variety.Rosters = rosters;
                    } else {
                        variety.Rosters = forecasts;
                    }
                                        
                    if (forecasts.length > 0) {
                        var forecatValue = null;
                        forecasts.forEach(f => {
                            if (f.RosterValue != null) {
                                if (forecatValue == null) {
                                    forecatValue = parseInt(f.RosterValue);
                                } else {
                                    forecatValue = forecatValue + parseInt(f.RosterValue);
                                }
                            }
                        })
                        variety.ForecastValue = forecatValue
                    }
                    if (variety.Rosters.length == 0 && forecasts.length == 0) {
                        variety.Rosters.push({
                            BerriesRosterID: -1,
                            PlantID: cropLocationRawData.PlantID,
                            CropLocationID: cropLocationRawData.CropLocationID,
                            VarietyID: variety.VarietyID,
                            TeamID: null,
                            RosterValue: null,
                            IsSpray: false,
                            RosterDate: moment(day.Date).format("YYYY-MM-DD"),
                            RequireRecalculate: false,
                            Delete: false
                        })
                    } 
                });

                if (dayModel.Varieties.length > 0) {
                    let isSpray = false;

                    var forecastDayValue = null;

                    dayModel.Varieties.forEach(v => {
                        if (v.ForecastValue != null) {
                            if (forecastDayValue == null) {
                                forecastDayValue = parseInt(v.ForecastValue);
                            } else {
                                forecastDayValue = forecastDayValue + parseInt(v.ForecastValue);
                            }
                        }

                        let teamRosters = v.Rosters.filter(r => r.TeamID != null)
                        teamRosters.forEach(tr => {
                            if(!rosteredTeamsInPeriod.includes(tr.TeamID)){
                                // console.log('rosteredTeamsInPeriod', rosteredTeamsInPeriod)
                                // console.log('team rosters for variety on day:', teamRosters)
                                rosteredTeamsInPeriod.push(tr.TeamID)
                                // console.log('rosteredTeamsInPeriod', rosteredTeamsInPeriod)
                            }
                        })

                        isSpray = v.Rosters.some(r => r.IsSpray == true);
                    });
                    
                    dayModel.ForecastDayValue = forecastDayValue;
                    
                    
                    // do not include previous day forecast value in the total location forecast value
                    if (!isSpray && (!showPreviousSunday || !moment(day.Date).isSame(previousDay, "day"))) {
                        locationForecastValue = locationForecastValue + (dayModel.ForecastDayValue || 0);
                    }

                    if(isSpray) {
                        //mark the whole crop location as spray for easy filtering
                        model.IsSprayTeam = isSpray
                    }
                }

                model.Days.push(dayModel);
            });

            model.LocationForecastValue = locationForecastValue;
            model.RosteredTeamIDs = rosteredTeamsInPeriod

            cropLocationModels.push(model);
        });

        let data = cropLocationModels.sort((a, b) => {
            let aText = `${a.LocationName} -  ${a.Varieties.length > 1 ? 'Mix' : a.Varieties[0].VarietyName}`;
            let bText = `${b.LocationName} -  ${b.Varieties.length > 1 ? 'Mix' : b.Varieties[0].VarietyName}`;

            return aText.localeCompare(bText);
        });

        /**
         * If includes data from the previous Sunday, then we need to set some flags so we know how to display
         * this data later. This will enable us to do things like prevent editing of any previous Sunday columns,
         * and not include the previous Sunday numbers in the totals.
         */
        if (showPreviousSunday) {
            for (let cropLocation of data) {
                let totalRosterValueOnPreviousDay = 0;
                let totalRosterValueOnNonPreviousDays = 0;

                for (let day of cropLocation.Days) {
                    day.IsPreviousDay = moment(day.Date).isSame(previousDay, "day");

                    for (let variety of day.Varieties) {
                        for (let roster of variety.Rosters) {
                            if (day.IsPreviousDay) {
                                totalRosterValueOnPreviousDay += roster.RosterValue || 0;

                                if (roster.IsSpray) {
                                    totalRosterValueOnPreviousDay += 1; // the value does not actually matter, just that it is above 0
                                }
                            }
                            else {
                                totalRosterValueOnNonPreviousDays += roster.RosterValue || 0;
                            }
                        }
                    }
                }

                if (totalRosterValueOnNonPreviousDays <= 0) {
                    // nothing is rostered to be picked in the regular week, only on the previous Sunday
                    cropLocation.PreviousDayOnly = true;
                }

                if (totalRosterValueOnPreviousDay <= 0) {
                    cropLocation.NoPreviousDayData = true;
                }
            }
        }

        return data;
    },
    getRosterTeamDefaultName(cropLocationVarietyRosterDay, teams) {
        if (cropLocationVarietyRosterDay != null) {
            var teamIDs = [... new Set(cropLocationVarietyRosterDay.Varieties.map(v => {
                return v.Rosters.map(r => {
                    return r.TeamID;
                }).flat();
            }).flat().filter(v => v))];
            if (teamIDs.length > 0) {
                var team = teams.find(t => t.TeamID == teamIDs[0]);
                if (team) {
                    return team.TeamName;
                }
            }
        }
        return "";

    },
    getRosterTeams(cropLocationVarietyDayRosters, teams) {
        // return unique roster team id for the crop location variety day rosters
        if (cropLocationVarietyDayRosters != null) {
            var teamIDs = [... new Set(cropLocationVarietyDayRosters.Varieties.map(v => {
                return v.Rosters.map(r => {
                    return r.TeamID;
                }).flat();
            }).flat().filter(v => v))];
          
            return teamIDs.map(teamID=> {
                var team = teams.find(t => t.TeamID == teamID);
                return team;
            }).sort((a, b) => {
                if(a.TeamName > b.TeamName) {
                    return 1;
                } else if(a.TeamName < b.TeamName) {
                    return -1;
                } else {
                    return 0;
                }
            })
        }
        return [];

    },
    generateNewRosterTeamPlans(teamIDs, days) {
        var teamPlansToBeAdded = [];
        teamIDs.forEach(teamID => {
            days.forEach(day => {
                teamPlansToBeAdded.push({ TeamID: teamID, Date: moment(day.Date).format("YYYY-MM-DD"), RosterDayOff: false, IsDelete: false});
            })
        })
        return teamPlansToBeAdded;
    },
    generateDeleteRosterTeamPlans(teamIDToBeDeleted, rosterTeamPlans) {
        var teamPlanToBeDeleted = [];
        teamPlanToBeDeleted = Object.assign([], rosterTeamPlans.filter(rt => teamIDToBeDeleted.indexOf(rt.TeamID) >= 0).map(rt => {
            rt.ISDelete = true;
            return rt;
        }));
        return teamPlanToBeDeleted;
    },
    generateMixedPopupItems(cropLocationVarieties, editingCropLocationVarieties, selectedTeams, originalSelectedTeams, teams) {
        var teamRosterItems = [];
        var varietyRosterItems = [];
        // Get Added TeamIDs and Removed TeamIDs
        var removedTeamIDs = [];
        var addedTeamIDs = [];
        originalSelectedTeams.forEach(teamID => {
            if (selectedTeams.indexOf(teamID) < 0) {
                removedTeamIDs.push(teamID);
            }
        })
        selectedTeams.forEach(teamID => {
            if (originalSelectedTeams.indexOf(teamID) < 0) {
                addedTeamIDs.push(teamID);
            }
        });
        // If there are team added, it will assign 0 value to it
        var hasTeamAdded = addedTeamIDs.length > 0;

        // For crop locaton's varieties, generate the team rosters list
        editingCropLocationVarieties.Varieties.forEach(v => {
            var varietyVolume = null;
            var varietyDecimalVolume = null;

            var deletedRosterValue = null;

            // If there is existing variety entry, it will use the value and divide the number of selected team for default roster value
            var variety = cropLocationVarieties.Varieties.find(va => va.VarietyID == v.VarietyID);
            var rosterValue = null;
            
            // Calculate the roster value by looping the roster enties under this variety
            variety.Rosters.filter(r => r.IsSpray == false && r.Delete == false).forEach(r => {
                if (r.RosterValue != null) {
                    if (rosterValue == null) {
                        rosterValue = parseInt(r.RosterValue);
                    } else {
                        rosterValue = rosterValue + parseInt(r.RosterValue);
                    }
                }
            })
            var deletedRosters = variety.Rosters.filter(r=> removedTeamIDs.indexOf(r.TeamID) >= 0);  
            deletedRosters.forEach(r => {
                if (r.RosterValue != null) {
                    if (deletedRosterValue == null) {
                        deletedRosterValue = parseInt(r.RosterValue);
                    } else {
                        deletedRosterValue = deletedRosterValue + parseInt(r.RosterValue);
                    }
                }
            });
            selectedTeams.filter(t => t > -1).forEach(t => {
                var teamVolume = null;
                var teamDecimalVolume = null;
                // Default the volumn to forecast value, need to allocation to the number of teams
                teamVolume = (variety != null && variety.ForecastValue != null) ? (Math.round(variety.ForecastValue / (selectedTeams.filter(t => t > -1).length))) : null;
                teamDecimalVolume = (variety != null && variety.ForecastValue != null) ? ((variety.ForecastValue / (selectedTeams.filter(t => t > -1).length))) : null;
                // If there are roster value, need to allocation to the number of teams
                if (rosterValue != null) {
                    teamVolume = parseInt(rosterValue / (selectedTeams.filter(t => t > -1).length));
                    teamDecimalVolume = rosterValue / ((selectedTeams.filter(t => t > -1).length) * 1.0);
                   
                }

                var existingRoster = variety.Rosters.find(r => r.TeamID == t);
                
                // If there is existing roster entry for this team under the variety, set the value into the existing roster value
                if (existingRoster) {
                    teamVolume = existingRoster.RosterValue;
                    teamDecimalVolume = existingRoster.RosterValue;
                } 
                // If there are new team added and no existing roster value, set the value to 0
                else if (hasTeamAdded && !existingRoster && originalSelectedTeams.length > 0) {
                    teamVolume = 0; 
                    teamDecimalVolume = 0;
                }
                teamRosterItems.push({
                    CropLocationID: cropLocationVarieties.CropLocationID,
                    LocationName: cropLocationVarieties.LocationName,
                    VarietyID: v.VarietyID,
                    VarietyName: v.VarietyName,
                    TeamID: t,
                    TeamName: teams.find(team => team.TeamID == t).TeamName,
                    Volume: teamVolume,
                    DecimalVolume: teamDecimalVolume
                })

                if (teamVolume != null) {
                    if (varietyVolume == null) {
                        varietyVolume = parseInt(teamVolume);
                    } else {
                        varietyVolume = varietyVolume + parseInt(teamVolume);
                    }
                    if (varietyDecimalVolume == null) {
                        varietyDecimalVolume = teamDecimalVolume;
                    } else {
                        varietyDecimalVolume = varietyDecimalVolume + teamDecimalVolume;
                    }
                }

            })
          
            // When there are team deselected, allocate the value into remaining existing rosterted team proportionally
            if(deletedRosterValue != null && deletedRosterValue > 0 && rosterValue > 0) {
                if (teamRosterItems.filter(t => t.VarietyID == v.VarietyID).length == 1) {
                    teamRosterItems.filter(t => t.VarietyID == v.VarietyID)[0].Volume = rosterValue;
                    teamRosterItems.filter(t => t.VarietyID == v.VarietyID)[0].DecimalVolume = rosterValue;
                } else {
                    teamRosterItems.filter(t=> t.VarietyID == v.VarietyID).forEach(t=> {
                        t.Volume = parseInt(t.Volume + deletedRosterValue * (t.Volume / (rosterValue - deletedRosterValue)));
                        t.DecimalVolume = (t.DecimalVolume + deletedRosterValue * (t.DecimalVolume / (rosterValue - deletedRosterValue)));

                    })
                }

                varietyVolume += deletedRosterValue;
                varietyDecimalVolume += deletedRosterValue;
               
            }
            //When there are no team selected but openning the mix allocaiton popup, only show the varieties allocation
            if (selectedTeams.filter(t => t > -1).length == 0) {
                varietyVolume = rosterValue == null ? variety.ForecastValue : rosterValue;
                varietyDecimalVolume =  rosterValue == null ? variety.ForecastValue : rosterValue;
            }   
          
            //This is the variety summary used in the popup footer 
            varietyRosterItems.push({
                VarietyName: v.VarietyName,
                VarietyID: v.VarietyID,
                Volume: varietyVolume + deletedRosterValue,
                DecimalVolume: varietyDecimalVolume
            })

        });
        if (teamRosterItems.length > 0) {
            varietyRosterItems.forEach(vri=> {
                var targetTotal = vri.DecimalVolume;
                var filteredTeamRosterIteams = teamRosterItems.filter(tri=> tri.VarietyID == vri.VarietyID);
                var newValues = filteredTeamRosterIteams.map(t=> t.Volume);
                var currentTotal = newValues.reduce((a, v) => a + v, 0);
            
                var allocatedValues = this.distrubuteValueEvenly(targetTotal, currentTotal, newValues);
                    filteredTeamRosterIteams.forEach((t, i) => {
                        t.Volume = allocatedValues[i];
                    });
                    vri.Volume = allocatedValues.reduce((a, v) => a + v, 0);
                
            })
        }
        return { teamRosterItems, varietyRosterItems };
    },
    combineTeamRosteredLocationDataIntoOneObjectPerLocation(originalData) {
        let newData = {};
        
        for (const locationVariety of originalData) {
            if (locationVariety.RosterValue && locationVariety.RosterValue > 0) {
                if (!newData[locationVariety.CropLocationID]) {
                    newData[locationVariety.CropLocationID] = {...locationVariety};
                }
                else {
                    newData[locationVariety.CropLocationID].VarietyName = "Mix";
                    newData[locationVariety.CropLocationID].VarietyID = [newData[locationVariety.CropLocationID].VarietyID];
                    newData[locationVariety.CropLocationID].VarietyID.push(locationVariety.VarietyID);
                    newData[locationVariety.CropLocationID].RosterValue += locationVariety.RosterValue;
                }
            }
        }

        let newDataArray = [];
        for (var cropLocationID in newData) {
            if (Object.prototype.hasOwnProperty.call(newData, cropLocationID)) {
                newDataArray.push(newData[cropLocationID]);
            }
        }

        return newDataArray;
    },
    getTeamRosteredLocationData(teamToGetDataFor, dayToGetDataFor, cropLocationVarietyRosters) {
        let data = [];

        for (const cropLocationVarietyRoster of cropLocationVarietyRosters) {
            for (const day of cropLocationVarietyRoster.Days) {
                if (this.isSameDate(day.Date, dayToGetDataFor.Date)) {
                    for (const variety of day.Varieties) {
                        for (const roster of variety.Rosters) {
                            if (roster.TeamID == teamToGetDataFor.TeamID) {
                                data.push({
                                    LocationName: cropLocationVarietyRoster.LocationName,
                                    CropLocationID: cropLocationVarietyRoster.CropLocationID,
                                    VarietyName: variety.VarietyName,
                                    VarietyID: variety.VarietyID,
                                    RosterValue: roster.RosterValue
                                });
                            }
                        }
                    }
                }
            }
        }

        return data;
    },
    getTeamRosteredLocationIDs(team, day, cropLocationVarietyRosters, excludePreviousDay) {
        var locationIDs = cropLocationVarietyRosters.filter(r=>  {
            var date = r.Days.find(d=> this.isSameDate(d.Date, day.Date));
         
            if (!excludePreviousDay || !date.IsPreviousDay) {
                if (date && date.Varieties.some(v=> v.Rosters.some(ro=> ro.TeamID == team.TeamID))) {
                    return true;
                    
                } else {
                    return false;
                }
            }
        }).map(l=> l.CropLocationID);
        return [... new Set(locationIDs)];
    },
    getTeamTotalRosteredLocationIDs(team, days, cropLocationVarietyRosters) {
        var ids = [];
        days.forEach(d=> {
            ids = ids.concat(this.getTeamRosteredLocationIDs(team, d, cropLocationVarietyRosters, true));
        });
        return ids;
    },
    getGrandTotalRosteredLocationIDs(cropLocationVarietyRosters) {
        var locationIDs = cropLocationVarietyRosters.filter(r => {
            if (r.Days.some(date => date.Varieties.some(v => v.Rosters.some(ro => ro.BerriesRosterID  > 0 && ro.IsSpray == false)) && !date.IsPreviousDay) ) {
                return true;

            } else {
                return false;
            }
        }).map(l => l.CropLocationID);
        return [... new Set(locationIDs)];   
    },
    getTeamRosteredVolume(team, day, cropLocationVarietyRosters, excludePreviousDay) {
        var value = null;

        cropLocationVarietyRosters.forEach(r => {
            var date = r.Days.find(d => this.isSameDate(d.Date, day.Date));
            
            if (!excludePreviousDay || !date.IsPreviousDay) {
                date.Varieties.forEach(v=> {
                    v.Rosters.filter(r=> r.TeamID == team.TeamID).forEach(r=> {
                        if (r.RosterValue != null) {
                            value = (value || 0) + parseInt(r.RosterValue);
                        }
                    })
                })
            }
        });

        return value == null ?  null : Math.round(value);
    },
    getTeamActualVolume(team, day, cropLocationVarietyRosters, uoms) {
        var value = null;

        var dayRoster = cropLocationVarietyRosters.find(r => this.isSameDate(r.Date, day.Date) && r.TeamID == team.TeamID);
        if(dayRoster){
            // console.log("team on day picked KG", team.TeamID, dayRoster.Date, dayRoster)
            dayRoster.Actuals.forEach(a => {
                value = (value || 0) + Math.round(a.TotalKg * uoms[a.ProductVarietyID].scaleFactor);
            })
        }

        return value == null ?  null : Math.round(value);
    },
    getTeamTotalVolume(team, days, cropLocationVarietyRosters) {
        var totalValue = null;
        days.forEach(d=> {
            var value = this.getTeamRosteredVolume(team, d, cropLocationVarietyRosters, true);
            
            totalValue = (totalValue || 0) + value;
        });
        
        return totalValue;
    },
    getTeamRDODays(team, rosterTeamPlansByTeam) {
        let dates = [];

        for (let day of rosterTeamPlansByTeam[team.TeamID].Days) {
            if (!day.IsPreviousDay && day.RosterDayOff) {
                dates.push(day.Date);
            }
        }

        dates.sort();

        return dates;
    },
    getTeamTotalRDOs(team, rosterTeamPlansByTeam) {
        let count = 0;

        for (let day of rosterTeamPlansByTeam[team.TeamID].Days) {
            if (!day.IsPreviousDay && day.RosterDayOff) {
                count++;
            }
        }

        return count;
    },
    getDayTotalRDOs(day, teams, rosterTeamPlans) {
        return rosterTeamPlans.filter(rtp => teams.find(t=> t.TeamID == rtp.TeamID) != null && this.isSameDate(rtp.Date, day.Date) && rtp.RosterDayOff == true).length;
    },
    getGrandTotalRDOs(rosterTeamPlansByTeam) {
        let count = 0;

        for(let teamID in rosterTeamPlansByTeam) {
            if (Object.prototype.hasOwnProperty.call(rosterTeamPlansByTeam, teamID)) {
                for (let day of rosterTeamPlansByTeam[teamID].Days) {
                    if (!day.IsPreviousDay && day.RosterDayOff) {
                        count++;
                    }
                }
            }
        }

        return count;
    },
    getDayActualVolume(day, teams, rosterTeamPlans, uoms){
        var actualsTotalValue = 0;
        
        var dayRosters = rosterTeamPlans.filter(r => this.isSameDate(r.Date, day.Date));
        // console.log('all of the rosters for day', day.Date, dayRosters)
        teams.forEach(t => {
            var dayTeamRoster = dayRosters.find(r => r.TeamID == t.TeamID)
            if(dayTeamRoster != null){
                dayTeamRoster.Actuals.forEach(a => {
                    actualsTotalValue += Math.round(a.TotalKg * uoms[a.ProductVarietyID].scaleFactor);
                })
            }
        })

        return actualsTotalValue;
    },
    getDayRemainingVolume(day, cropLocationVarietyRosters) {
        var rosteredValue = null;
        var totalValue = null;
        cropLocationVarietyRosters.forEach(clvr=> {
            var dayVarityRosters = clvr.Days.find(d=> this.isSameDate(d.Date, day.Date));
            if (dayVarityRosters) {
                dayVarityRosters.Varieties.forEach(v=> {
                    v.Rosters.filter(r=> r.IsSpray == false && r.RosterValue != null).forEach(r=> {
                        
                        if (totalValue == null) {
                            totalValue = parseInt(r.RosterValue);
                        } else {
                            totalValue = parseInt(totalValue) + parseInt(r.RosterValue);
                        }

                        if(r.TeamID != null && r.TeamID > 0) {
                            if (rosteredValue == null) {
                                rosteredValue = parseInt(r.RosterValue);
                            } else {
                                rosteredValue = parseInt(rosteredValue) + parseInt(r.RosterValue);
                            }
                        }
                        
                    })
                })
            }
        })
      
        if(rosteredValue == null && totalValue == null) {
            return null;
        }  else if (rosteredValue == null && totalValue != null) {
            return - totalValue;
        }else {
            return Math.round(((rosteredValue || 0) - totalValue || 0));
        }
    },
    getDayRemainingVolumeToolTips(day, cropLocationVarietyRosters, uom) {
        var lines = [];
        var rosteredValue = null;
        var totalValue = null;

        cropLocationVarietyRosters.forEach(clvr=> {
            var dayVarityRosters = clvr.Days.find(d=> this.isSameDate(d.Date, day.Date));
            if (dayVarityRosters) {
                dayVarityRosters.Varieties.forEach(v=> {
                    v.Rosters.filter(r=> r.IsSpray == false && r.RosterValue != null).forEach(r=> {
                        if (totalValue == null) {
                            totalValue = parseInt(r.RosterValue);
                        } else {
                            totalValue = parseInt(totalValue) + parseInt(r.RosterValue);
                        }

                        if(r.TeamID != null && r.TeamID > 0) {
                            if (rosteredValue == null) {
                                rosteredValue = parseInt(r.RosterValue);
                            } else {
                                rosteredValue = parseInt(rosteredValue) + parseInt(r.RosterValue);
                            }
                        } else {
                            lines.push(clvr.LocationName + " - " + parseInt(r.RosterValue) + uom);
                        }
                    })
                })
            }
        })

        return lines;
    },
    getDayRemainingLocations(day, cropLocationVarietyRosters) {
        // get total forecasted locations and total rostered locations and return the diff
        var totalLocations = cropLocationVarietyRosters.filter(clvr=> {
            var dayVarityRosters = clvr.Days.find(d => this.isSameDate(d.Date, day.Date));
            if(dayVarityRosters) {
                if (dayVarityRosters.Varieties.every(v => v.Rosters.some(r => r.IsSpray) || v.Rosters.some(r => r.RosterValue == null))) {
                    return false;
                } else {
                    // do not count this if there is not actually any value rostered to be picked
                    if (dayVarityRosters.Varieties.some(v => v.Rosters.some(r => r.RosterValue && r.RosterValue > 0))) {
                        return true;
                    }
                    else {
                        return false;
                    }
                    
                }
            } else {
                return false;
            }
        }).length;

        var totalRosteredLocations = 0;

        cropLocationVarietyRosters.forEach(clvr => {
            var dayVarityRosters = clvr.Days.find(d => this.isSameDate(d.Date, day.Date));
            if(dayVarityRosters) {
                if (dayVarityRosters.Varieties.some(v => v.Rosters.some(r => r.IsSpray == false && r.RosterValue != null && r.RosterValue > 0 && r.BerriesRosterID > 0 && r.TeamID != null))) {
                    totalRosteredLocations = totalRosteredLocations + 1;
                }
            }
        });
     
        return totalRosteredLocations - totalLocations;
    },
    getGrandTotalVolume(cropLocationVarietyRosters) {
        var volume = 0;

        cropLocationVarietyRosters.forEach(clvr => {
            clvr.Days.forEach(day => {
                if (day != null && !day.IsPreviousDay) {
                    day.Varieties.forEach(v => {
                        v.Rosters.forEach(r => {
                            if (r.RosterValue != null) {
                                volume = volume + parseInt(r.RosterValue);
                            }
                        })
                    })
                }
            })
        });

        return Math.round(volume);
    },
    getGrandTotalVolumeExcludingSpray(cropLocationVarietyRosters) {
        var volume = 0;

        cropLocationVarietyRosters.forEach(clvr => {
            clvr.Days.forEach(day => {
                if (day != null && !day.IsPreviousDay) {
                    day.Varieties.forEach(v => {
                        v.Rosters.filter(r => r.IsSpray == false).forEach(r => {
                            if (r.RosterValue != null) {
                                volume = volume + parseInt(r.RosterValue);
                            }
                        })
                    })
                }
            })
        });

        return Math.round(volume);
    },
    getGrandTotalActualsVolume(teams, days, cropLocationVarietyRosters, uoms) {
        var totalActualValue = 0;
        teams.forEach(team=> {
            days.forEach(d => {
                var value = this.getTeamActualVolume(team, d, cropLocationVarietyRosters, uoms);
                /* if(value > 0){
                    console.log('total actual volume including', team, d)
                } */
                totalActualValue = (totalActualValue) + value;
            });
        })
       
        return totalActualValue;
    },
    getGrandTotalRosteredVolume(teams, days, cropLocationVarietyRosters) {
        var totalValue = null;
        teams.forEach(team=> {
            days.forEach(d => {
                var value = this.getTeamRosteredVolume(team, d, cropLocationVarietyRosters, true);

                totalValue = (totalValue || 0) + value;
            });
        })
       
        return totalValue;
    },
    formatThousandsSeparators(num) {
        if (num == null) return "";

        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
    },
    hasAllocatedVolumeForTeam(teamID, cropLocationVarietyRosters) {
        return cropLocationVarietyRosters.some(clvr=> {
            return clvr.Days.some(d=> {
                return d.Varieties.some(v=> {
                    return v.Rosters.some(r=> {
                     return r.TeamID == teamID && r.IsSpray == false && r.RosterValue != null;
                    })
                })
            })
        })
    },
    deallocateDayVolumeForTeam(teamID, date, cropLocationVarietyRosters, teams) {
        // This method lopp the crop location varities and find the allocated team with the given team id
        // And then deallocate the volume for this team and allocate into remaining team
        var cropLocationDaysVarietyRosterList = [];
        cropLocationVarietyRosters.forEach(clvr=> {
            var cropLocationVarietyDayRosters = clvr.Days.find(d=> this.isSameDate(d.Date, date));
            if(cropLocationVarietyDayRosters) {
                var teamIDs = [];
                cropLocationVarietyDayRosters.Varieties.forEach(v=> {
                    v.Rosters.filter(r=> r.TeamID > 0).forEach(r=> {
                        teamIDs.push(r.TeamID);
                    });
                })
                // generate unique team id and call the methods to generate team items
                var uniqueTeamIDs = [... new Set(teamIDs)];
                if(uniqueTeamIDs.indexOf(teamID) >= 0) {
                    var items = this.generateMixedPopupItems(cropLocationVarietyDayRosters, clvr, uniqueTeamIDs.filter(t=> t != teamID), uniqueTeamIDs, teams);
                    if(items.teamRosterItems.length > 0) {
                        var updatedTeamRosters = this.addUpdateMixedTeamRosters(clvr, cropLocationVarietyDayRosters, items.teamRosterItems);
                        cropLocationDaysVarietyRosterList.push(updatedTeamRosters);
                    } else {
                        var updatedVarityRosters = this.addUpdateTeamRosters(cropLocationVarietyDayRosters, [])
                        cropLocationDaysVarietyRosterList.push(updatedVarityRosters);
                    }
                }
            }
        })
        return cropLocationDaysVarietyRosterList;
    },
    distrubuteValueEvenly(targetTotal, currentTotal, newValues) {
        // Distribute the remainder
        let totalRemaining = targetTotal - currentTotal;
        let i = 0;
        let loopsWithoutDoingAnything = 0;
        while (totalRemaining > 0 && newValues.length > 0) {
            if (newValues[i] != 0) {
                newValues[i] += 1;
                totalRemaining--;
            } else {
                loopsWithoutDoingAnything++;
                if (loopsWithoutDoingAnything == newValues.length) {
                    break;
                }
            }

            i = (i + 1) % newValues.length;
        }
        i = newValues.length - 1;
        loopsWithoutDoingAnything = 0;
        while (totalRemaining < 0 && newValues.length > 0) {
            if (newValues[i] > 0) {
                newValues[i] -= 1;
                totalRemaining++;
            } else {
                loopsWithoutDoingAnything++;
                if (loopsWithoutDoingAnything == newValues.length) {
                    break;
                }
            }

            i--;
            if (i < 0) {
                i = newValues.length - 1;
            }
        }

        return newValues;
    }
}
